<script>
import Layout from '@layouts/auth'
import { authMethods } from '@state/helpers'
import appConfig from '@src/app.config'
export default {
  props: {
    user: {
      type: Object,
      required: false,
      default: () => ({})
    },
  },
  page: {
    title: 'Confirm',
    meta: [{ name: 'description', content: `Confirm account to ${appConfig.title}` }],
  },
  components: { Layout },
  data() {
    return {

    }
  },
  computed: {
  },
  methods: {
    ...authMethods,
  },
}
</script>

<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card">
          <div class="card-body p-4">
            <div class="text-center w-75 m-auto">
              <a href="/">
                <span><img src="@assets/images/logo-sm-dark.png" alt="" height="21"/> </span>
                <h3 class="d-inline align-top ml-1 text-uppercase">{{app_name}}</h3>
              </a>
            </div>

            <div class="mt-3 text-center">
              <h3>Your account was registered successfully</h3>
              <p class="text-muted mt-2"> An email has been sent to <span class="font-weight-medium">{{user.email}}</span>.
                  Please check your email from {{app_name}} and click on the included link to activate your account.</p>

              <router-link tag="a" to="/" class="btn btn-block btn-primary waves-effect waves-light mt-3">Back to Home</router-link>
            </div>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<style lang="scss" module></style>
